import { render, staticRenderFns } from "./UpsellModal.vue?vue&type=template&id=6086de63&scoped=true&"
import script from "./UpsellModal.vue?vue&type=script&lang=js&"
export * from "./UpsellModal.vue?vue&type=script&lang=js&"
import style0 from "./UpsellModal.vue?vue&type=style&index=0&id=6086de63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6086de63",
  null
  
)

export default component.exports